import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Código", value: true },
    { title: "Nombre", value: true },
    { title: "Saldo", value: true },
    { title: "Tipo", value: true },
    { title: "Grupo", value: true },
    { title: "Moneda", value: true },
    { title: "RUT", value: true },
];

class BussinesPartnerView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            total: 0,
            priceList: [],
            groupCodes: [],
            listEmployees: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
        }
    }

    componentDidMount = async () => {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "lisocios");
        let listPricesResult = await apiClient.getPriceList();
        let listGroupCode = await apiClient.getGroupCode();
        let listEmployeeResult = await apiClient.getEmployeeList();

        this.setState({
            priceList: listPricesResult.data,
            groupCodes: listGroupCode.data,
            listEmployees: listEmployeeResult.data,
        })
    }

    searchPartners = async filter => {
        await this.callDocumentsListService(filter);
    };

    callDocumentsListService = async (filter = { priceValue: '---', groupCodeValue: '---', employeeValue: '---' }) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let businesPartnerResponse = await apiClient.getPartnerList(filter);
        enableSpinner(false);

        if (businesPartnerResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: businesPartnerResponse.data.partners,
                total: businesPartnerResponse.data.totalRows
            });
        }
    };

    render() {
        const { headers, data, total, priceList, listEmployees, groupCodes, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'SOCIO DE NEGOCIOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <label id="lisocios" className="h2 text-muted"> SOCIO DE NEGOCIOS </label>
                    <DataTables
                        headers={headers}
                        view={"bussinesPartner"}
                        data={data}
                        search={this.searchPartners}
                        totalRows={total}
                        priceList={priceList}
                        listEmployees={listEmployees}
                        groupCodes={groupCodes} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BussinesPartnerView);
